import { FC } from "react";
import Layout from "../../components/layout/Layout";
import { Box } from "@mui/material";
import Form from "./components/Form/Form";

interface ComplaintProps {

}

const Complaint: FC<ComplaintProps> = () => {
    return (
        <Layout title="Reklamacja">
            <Box display='flex' justifyContent='center'>
                <Box maxWidth={900} width='100%'>
                    <Form />
                </Box>
            </Box>
        </Layout>
    )
}

export default Complaint;